//MUI components
import { Box, Typography, Grid2, useMediaQuery, Select, MenuItem } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

//images
import bancoDeCapacitores from "../../assets/images/productos/bancoCapacitores/BANCODECAPACITORES.png";
import eHouse from "../../assets/images/productos/eHouse/EHOUSE.png";
import emafluorc from "../../assets/images/productos/Emafluorc/emafluorc.png";
import hvcb from "../../assets/images/productos/hvcb/HVCB - 1.png";
import hvcb72 from "../../assets/images/productos/hvcb72DT/HVCB 72 DT 2.png";
import modulpack36 from "../../assets/images/productos/modulpack36r/modulpack36.png";
import sge from "../../assets/images/productos/sge/sge.png";
import subestacionMovil from "../../assets/images/productos/subestacionMovil/subestacionMovil.png";
import umi from "../../assets/images/productos/umi/UMI - 1.png";
import unimetC from "../../assets/images/productos/unimetC/unimetC.png";
import unimetD from "../../assets/images/productos/unimetD/unimetD.png";
import unimetH from "../../assets/images/productos/unimetH/unimetH - chico.png";
import vdh from "../../assets/images/productos/vdh/VDH.png";
import vdh15 from "../../assets/images/productos/vdh/VDH15.png";
import vdhArg from "../../assets/images/productos/vdhgsmi/vdharg.png";
import ve from "../../assets/images/productos/ve/VE.png";
import vee from "../../assets/images/productos/vee/vee.png";
import logoBlanco from "../../assets/images/EMA_blanco_chico.png";

//My Components
import OptionsTab from "../optionsBar";
import ProductsCard from "../card";
import "./styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ─── Shared card props ───────────────────────────────────────────────────────

const FRONT_COMMON = {
  paddingX: "2rem",
  paddingY: "2rem",
  text1Align: "left",
  text2Align: "left",
  height: "31.5rem",
  heightColor: "17rem",
  marginTopText2: "1rem",
};

const BACK_COMMON = {
  image: logoBlanco,
  marginTopImage: "12.5rem",
  paddingX: "2rem",
  paddingY: "2rem",
  text1Align: "center",
  text2Align: "center",
  height: "31.5rem",
  heightColor: "32rem",
  marginTopText2: "25rem",
};

const MOBILE_COMMON = {
  paddingX: "2rem",
  paddingY: "2rem",
  text1Align: "left",
  text2Align: "left",
  height: "31.5rem",
  heightColor: "12rem",
  marginTopText2: "1rem",
  marginTopImage: "2rem",
  isMobile: true,
};

// ─── Product definitions ─────────────────────────────────────────────────────
// Each product: { image, text, textKey, route, marginTopImage?, marginLeftImage? }

const useTabsConfig = (t) => [
  {
    labelKey: "celdas_primarias",
    products: [
      { image: unimetD,     text: "Unimet D",        textKey: "unimetD.titulo_tarjeta",      route: "/productos/unimet-d",       marginTopImage: "2rem"  },
      { image: unimetC,     text: "Unimet C",         textKey: "unimetC.titulo_tarjeta",      route: "/productos/unimet-c",       marginTopImage: "1rem"  },
      { image: modulpack36, text: "Modulpack 36R",    textKey: "modulpack36R.titulo_tarjeta", route: "/productos/modulpack36R",   marginTopImage: "2rem"  },
      { image: unimetH,     text: "Unimet H",         textKey: "unimetH.titulo_tarjeta",      route: "/productos/unimet-h",       marginTopImage: "2.5rem"},
    ],
  },
  {
    labelKey: "celdas_secundarias",
    products: [
      { image: emafluorc, text: "Emafluorc", textKey: "emafluorc.titulo_tarjeta", route: "/productos/emafluorc", marginTopImage: "2rem" },
    ],
  },
  {
    labelKey: "media_tension",
    products: [
      { image: ve,     text: "VE",       textKey: "ve.titulo_tarjeta",       route: "/productos/ve",       marginTopImage: "3rem"              },
      { image: vee,    text: "VEE",      textKey: "vee.titulo_tarjeta",      route: "/productos/vee",      marginTopImage: "2.5rem"            },
      { image: vdh,    text: "VDH/GSMI", textKey: "vdh-gsmi.titulo_tarjeta", route: "/productos/vdh-gsmi", marginTopImage: "1rem"              },
      { image: vdhArg, text: "VDH",      textKey: "vdh.titulo_tarjeta",      route: "/productos/vdh",      marginTopImage: "1.5rem", marginLeftImage: "-1rem"  },
      { image: vdh15,  text: "VDH-15",   textKey: "vdh-15.titulo_tarjeta",   route: "/productos/vdh-15",   marginTopImage: "1.5rem"            },
    ],
  },
  {
    labelKey: "alta_tension",
    products: [
      { image: hvcb,   text: "HVCB",      textKey: "hvcb.titulo_tarjeta",    route: "/productos/hvcb",   marginTopImage: "1rem", marginLeftImage: "-1.5rem" },
      { image: hvcb72, text: "HVCB 72 DT",textKey: "hvcb72dt.titulo_tarjeta",route: "/productos/hvcb72", marginTopImage: "-2.5rem"                             },
      { image: sge,    text: "SGE",        textKey: "sge.titulo_tarjeta",     route: "/productos/sge",    marginTopImage: "1rem"                             },
    ],
  },
  {
    labelKey: "soluciones_integrales",
    products: [
      { image: subestacionMovil, text: "Subestación Movil",  textKey: "subestacionMovil.titulo_tarjeta", route: "/productos/subestacion-movil", marginTopImage: "4rem" },
      { image: eHouse,           text: "E House",            textKey: "e-house.titulo_tarjeta",          route: "/productos/eHouse",            marginTopImage: "4rem" },
      { image: umi,              text: "UMI",                textKey: "umi.titulo_tarjeta",              route: "/productos/umi",               marginTopImage: "2rem" },
      { image: bancoDeCapacitores, text: "Banco de Capacitores", textKey: "bancoCapacitores.titulo_tarjeta", route: "/productos/banco-capacitores", marginTopImage: "4rem" },
    ],
  },
];

// ─── Sub-components ──────────────────────────────────────────────────────────

function DesktopCard({ product, onNavigate, verMasLabel }) {
  const { image, text, text2, route, marginTopImage, marginLeftImage } = product;

  return (
    <Grid2
      item="true"
      style={{ marginRight: "1.8rem", cursor: "pointer" }}
      onClick={() => onNavigate(route)}
    >
      <div className="card-container">
        <div className="card">
          <div className="card-front">
            <ProductsCard
              {...FRONT_COMMON}
              image={image}
              text={text}
              text2={text2}
              marginTopImage={marginTopImage}
              marginLeftImage={marginLeftImage}
            />
          </div>
          <div className="card-back">
            <ProductsCard
              {...BACK_COMMON}
              text={text}
              text2={verMasLabel}
            />
          </div>
        </div>
      </div>
    </Grid2>
  );
}

function MobileSlide({ product, onNavigate }) {
  const { image, text, text2, route } = product;

  return (
    <SwiperSlide
      onClick={() => onNavigate(route)}
      style={{ display: "flex", justifyContent: "center" }}
    >
      <ProductsCard
        {...MOBILE_COMMON}
        image={image}
        text={text}
        text2={text2}
      />
    </SwiperSlide>
  );
}

// ─── Main component ───────────────────────────────────────────────────────────

function ProductosComponent() {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:768px)");

  const tabsConfig = useTabsConfig(t);

  // Hydrate translated text2 into each product
  const tabs = tabsConfig.map((tab) => ({
    ...tab,
    label: t(tab.labelKey),
    products: tab.products.map((p) => ({ ...p, text2: t(p.textKey) })),
  }));

  const verMasLabel = (
    <>
      {t("ver_mas")} <ArrowRight size={16} style={{ verticalAlign: "middle" }} />
    </>
  );

  useEffect(() => {
    const savedTab = localStorage.getItem("selectedProductTab");
    if (savedTab) setSelectedTab(parseInt(savedTab));
  }, []);

  const handleTabChange = (newValue) => {
    setSelectedTab(newValue);
    localStorage.setItem("selectedProductTab", newValue.toString());
  };

  const activeProducts = tabs[selectedTab]?.products ?? [];

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflowX: "hidden",
        overflowY: "hidden",
        background: "#FFF",
      }}
    >
      <Box
        style={{
          marginTop: "6rem",
          marginBottom: "4rem",
          paddingLeft: "1rem",
          paddingRight: "1rem",
        }}
      >
        <Typography
          style={{
            color: "#1B2466",
            fontFamily: "Montserrat",
            fontWeight: 800,
            fontSize: "clamp(2rem, 5vw, 3.5rem)",
            lineHeight: "1.2",
            textAlign: "center",
            letterSpacing: "-0.1px",
          }}
        >
          {t("nuestros_productos_titulo")}
        </Typography>
      </Box>

      {isMobile ? (
        <>
          {/* Mobile: Select + Swiper */}
          <Box sx={{ px: 2, mb: 3, mt: -2 }}>
            <Select
              fullWidth
              value={selectedTab}
              onChange={(e) => handleTabChange(e.target.value)}
              sx={{
                backgroundColor: "#F5F5F5",
                borderRadius: "12px",
                color: "#1B2466",
                fontWeight: 600,
                fontFamily: "Montserrat",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1B2466" },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1B2466" },
                "& .MuiSvgIcon-root": { color: "#1B2466" },
              }}
            >
              {tabs.map((tab, i) => (
                <MenuItem key={i} value={i}>{tab.label}</MenuItem>
              ))}
            </Select>
          </Box>

          <Box sx={{ px: 1, justifyContent: "center", alignContent: "center" }}>
            <Swiper
              centeredSlides
              centeredSlidesBounds
              grabCursor
              pagination={{ clickable: true }}
              modules={[Pagination]}
              style={{ paddingBottom: "2rem" }}
            >
              {activeProducts.map((product) => (
                <MobileSlide key={product.route} product={product} onNavigate={navigate} />
              ))}
            </Swiper>
          </Box>
        </>
      ) : (
        /* Desktop: Tabs + flip cards */
        <OptionsTab
          value={selectedTab}
          onChange={handleTabChange}
          labels={tabs.map((tab) => tab.label)}
        >
          {tabs.map((tab) => (
            <Grid2 key={tab.labelKey} container alignItems="center">
              {tab.products.map((product) => (
                <DesktopCard
                  key={product.route}
                  product={product}
                  onNavigate={navigate}
                  verMasLabel={verMasLabel}
                />
              ))}
            </Grid2>
          ))}
        </OptionsTab>
      )}
    </div>
  );
}

export default ProductosComponent;